<template>
  <v-card v-if='items'>
    <v-card-title>
      <b class='uppercase'>{{ title }}</b>
      <v-spacer></v-spacer>
      <div v-if='formType'>

        <slot name='pen' :input='input' :id='object.Id'>
          <v-tooltip bottom>
            <template v-slot:activator='{ on, attrs }'>
              <v-btn
                  type='button'
                  @click='input.isEdit = !input.isEdit'
                  :color="input.isEdit ? 'primary' : ''"
                  icon
                  v-bind='attrs'
                  v-on='on'
              >
                <v-icon>
                  mdi-pen
                </v-icon>
              </v-btn>
            </template>
            <span>ИЗМЕНИТЬ</span>
          </v-tooltip>
        </slot>
        <slot name='header' :input="input" :id='object.Id'></slot>
      </div>
    </v-card-title>
    <v-form ref='form' v-model='input.isFormValid'>
      <v-container fluid>

        <v-row class='pa-4'>
          <div v-for='(item, index) in entity' :class='attrs(keys[item]).grid' :key='index'>

            <slot v-if="typeof object[objectKey(item)[0]] !== 'object' || object[objectKey(item)[0]] == null"
                  :name='item'
                  :attrs="attrs(keys[item])"
                  :object='object[objectKey(item)[0]]'
                  :disabled='!input.isEdit'
                  :input='input'
                  :rules='rule(keys[item].rules)'>

              <testcom :key='index' v-if="attrs(keys[item]).content !== 'date-picker'"
                       v-bind='attrs(keys[item])'
                       :disabled='!input.isEdit'
                       @input='$emit(item,object[objectKey(item)[0]])'
                       :rules='rule(keys[item].rules)'
                       v-model='object[objectKey(item)[0]]'
              />

              <date-picker v-else-if="attrs(keys[item]).content === 'date-picker'"
                           :item='object'
                           :class='attrs(keys[item]).class'
                           :itemKey='objectKey(item)[0]'
                           :vInput='input'
                           :attr='attrs(keys[item])'
                           :keys='keys[item]'
              />

            </slot>

            <slot v-if="typeof object[objectKey(item)[0]] === 'object' && object[objectKey(item)[0]] != null"
                  :name='item'
                  :object='object[objectKey(item)[0]]'
                  :input='input'
                  :rules='rule(keys[item].rules)'
            >
              <testcom v-if="attrs(keys[item]).content !== 'date-picker'"
                       v-bind='attrs(keys[item])'
                       :disabled='!input.isEdit'
                       @input="$emit(`${objectKey(item)[0]}${(objectKey(item)[1] || '')}`,object[objectKey(item)[0]][objectKey(item)[1]])"
                       :rules='rule(keys[item].rules)'
                       v-model='object[objectKey(item)[0]][objectKey(item)[1]]'
              />

              <date-picker v-else-if="attrs(keys[item]).content === 'date-picker'"
                           :class='attrs(keys[item]).class'
                           :item='object[objectKey(item)[0]]'
                           :vInput='input'
                           :attr='attrs(keys[item])'
                           :itemKey='objectKey(item)[0]'
                           :keys='keys[item]'
              />

            </slot>
          </div>
        </v-row>
      </v-container>

    </v-form>
    <v-card-actions class='pa-4'>
      <slot name='saveBtn'
            :input='input'
            :method='{action:validate}'
      >
        <v-btn
            @click='validate'
            color='primary'
            :loading='input.isLoading'
            :disabled='!input.isLoading && !input.isEdit'
        >
          Сохранить
        </v-btn>
      </slot>

      <slot name='closeBtn'
            :input='input'
            :method='{action:toPrevPage}'
      >
        <v-btn text color='normal'
               @click='toPrevPage'
               :disabled='input.isLoading'
        >
          Назад
        </v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    items: Object,
    keys: Object,
    resultMgs: Function,
    createForm: Boolean,
    inputIsEdit: Boolean,
    formCallback: Function,
    successMessage: String
  },
  components: {
    DatePicker: () => import('@/components/helper/form/oil.date.picker.vue'),
    testcom: () => import('@/components/helper/form/testcom')
  },
  data() {
    return {
      input: {
        isFormValid: true,
        isEdit: false,
        isLoading: false,
      },
      rules: {
        required: value => {
          if (typeof value === 'boolean' || typeof value === 'number')
            return true
          else {
            return !!value || 'Поле обязательно для ввода'
          }
        },
        phone: (valid, value) => {
          if (valid.required) {
            if (typeof value === 'boolean' || typeof value === 'number')
              return true
            else {
              return !!value || 'Поле обязательно для ввода'
            }
          } else if (value) {
            const match = /^([+]\d+)(\W)?(\d+)(\W)?(\d+)(\W)?(\d+)(\W)?(\d+)$/
            return match.test(value) || 'Неверный формат телефона'
          }
          return true
        },
        number: (valid, value) => {
          if (valid.required) {
            if (typeof value === 'boolean' || typeof value === 'number')
              return true
            else {
              return !!value || 'Поле обязательно для ввода'
            }
          } else if (value) {
            return !isNaN(parseInt(value)) || 'Можно вводить только числа'
          }
          return true
        },
        min: (valid, value) => {
          value = value.toString()

          if (valid.required) {
            if (typeof value === 'boolean' || typeof value === 'number')
              return true
            else {
              return !!value || 'Поле обязательно для ввода'
            }
          } else if (value) {
            return value.trim().length >= (valid.length || 6) || `Минимум ${(valid.length || 6)} символов`
          }
          return true
        },
        max: (valid, value) => {
          value = value.toString()
          if (valid.required) {
            if (typeof value === 'boolean' || typeof value === 'number')
              return true
            else {
              return !!value || 'Поле обязательно для ввода'
            }
          } else if (value) {
            return value.trim().length <= (valid.length || 6) || `Не более ${(valid.length || 6)} символов`
          }
          return true
        },
        email: () => 'The email and password you entered don\'t match'
      },
      object: {}
    }
  },
  created() {
    this.input.isEdit = this.inputIsEdit || false
    this.object = this.items
  },
  computed: {
    entity() {
      return Object.keys(this.keys)
    },
    formType() {
      if (this.createForm == null || this.createForm === true) {
        this.input.isEdit = true
        return false
      }
      return true
    }
  },
  methods: {
    gotupdf({Id}) {
      window.open(`http://oilterminal.zucco.tech/api/contract/print/${Id}`)
    },
    gotoApp({Id}) {
      this.$router.push({
        path: `/additional-contract-create/${Id}`
      })
    },
    ucfirst(name) {
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    objectKey(name) {
      return name.split('.')
    },
    rule(rul) {
      if (Array.isArray(rul)) {
        const result = []
        for (const r of rul) {
          if (typeof r === 'string')
            result.push(this.rules[r])
          else if (typeof r === 'object') {
            const key = Object.keys(r)[0]
            const obj = {
              valid: r[key]
            }
            result.push(this.rules[key].bind(null, r[key]))
          }
        }
        return result
      }
      return []
    },
    attrs(arg) {
      if (arg.attrs)
        return arg.attrs
      return {}
    },
    key() {
      return this.keys
    },
    mergeKey(name) {
      const kv = this.objectKey(name)
      return kv[0] + this.ucfirst(kv[1])
    },
    async validate() {

      this.$refs.form.validate()

      if (!this.input.isFormValid) {
        const {$children} = this.$refs.form
        $children?.forEach(child => {
          if (child.valid === true) return
          const {$attrs} = child

          const keys = Object.keys($attrs)
          if (keys?.length > 0)
            this.$notify({
              group: 'mgs',
              type: 'error',
              title: `Ошибка! Поле ${$attrs?.label} обязательно для ввода`,
              timestamp: 2000
            })
        })
        return
      }

      if (this.formCallback) {

        this.input.isLoading = true
        await this.formCallback(this.object,
            this.input,
            this.$refs.form,
            (title) => {
              this.$notify({
                group: 'mgs',
                type: 'success',
                title: title || 'Удачно сохранено',
                timestamp: 5000
              })
            }
        )
        this.input.isLoading = false
      }
    },
    toPrevPage() {
      this.$router.back()
    }
  }
}
</script>
<style scoped>
.uppercase {
  text-transform: uppercase;
}
</style>